export const useCasesTabsOptions = [
  { value: 'recent', label: 'Most recent' },
  { value: 'popular', label: 'Most popular' },
]
